import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError, Observable } from 'rxjs';

import { BasedataService } from '../shared/basedata.service';
import { Status, StatusData } from './status';
import { ConfigService } from '@docma-mm-core/config/config.service';

const savedProjectStatusListKey = 'mm-savedProjectStatusList';

@Injectable()
export class StatusService extends BasedataService {

  private projectUrl = '/projects/';
  private statusUrl = '/status';

  constructor(private http: HttpClient, configService: ConfigService) {
    super(configService);
  }

  private getStatusUrl() {
    return super.getFullUrl(this.statusUrl);
  }

  private getProjectStatusUrl(projectId: number) {
    return super.getFullUrl(this.projectUrl + projectId + this.statusUrl);
  }


  // get status list
  getStatusList(top: number = 1000, skip: number = 0): Observable<StatusData> {
    const endpoint = this.getStatusUrl();
    let httpParams = new HttpParams();
    if (top) {
      httpParams = httpParams.set('$top', top.toString());
    }
    if (skip) {
      httpParams = httpParams.set('$skip', skip.toString());
    }
    return this.http
      .get<StatusData>(endpoint, { headers: this.getHeaders(), params: httpParams })
      .pipe(catchError(e  => this.handleError(e)));
  }

  // get status list by project
  getProjectStatusList(projectId: number, top: number = 1000, skip: number = 0): Observable<StatusData> {
    const endpoint = this.getProjectStatusUrl(projectId);
    let httpParams = new HttpParams();
    if (top) {
      httpParams = httpParams.set('$top', top.toString());
    }
    if (skip) {
      httpParams = httpParams.set('$skip', skip.toString());
    }

    httpParams = httpParams.set('includeLocked', true);

    return this.http
      .get<StatusData>(endpoint, { headers: this.getHeaders(), params: httpParams })
      .pipe(catchError(e  => this.handleError(e)));
  }

  // get status list locks by project
  getProjectStatusLocksList(projectId: number, top: number = 1000, skip: number = 0): Observable<StatusData> {
    const endpoint = this.getProjectStatusUrl(projectId) + '/locks';
    let httpParams = new HttpParams();
    if (top) {
      httpParams = httpParams.set('$top', top.toString());
    }
    if (skip) {
      httpParams = httpParams.set('$skip', skip.toString());
    }
    return this.http
      .get<StatusData>(endpoint, { headers: this.getHeaders(), params: httpParams })
      .pipe(catchError(e  => this.handleError(e)));
  }

}
